import { apiRequest } from "../api/apiService";

export const getGroupDetails = async () => {
    return apiRequest({
        method: "GET",
        url: "/group/list",
    });
};

export const updateGroup = async (payload) => {
    return apiRequest({
        method: "POST",
        url: "/group/update-group",
        data: payload,
    });
};

export const updateGroupAssets = async (payload) => {
    return apiRequest({
        method: "POST",
        url: "/group/update-group-assets",
        data: payload,
        headers: {
            "Content-Type": "application/json",
        },
    });
};
